import { FeatureFlag } from '@components/FeatureFlag'
import { getLocalStorage } from '@helpers/storage'
import CleanLayout from '@layouts/Clean'
import { PAYMENTS } from '@routes/path'
import { Navigate, useLocation } from 'react-router-dom'

import { CheckoutWrapper } from './CheckoutWrapper'
import { Configure } from './Configure'
import { Confirmation } from './Confirmation'
import { CHECKOUT_CURRENT_STEP } from './constants'
import { CheckoutProvider, useCheckoutContext } from './contexts'
import { Payment } from './Payment'
import { Plans } from './Plans'

const CheckoutStepsRedirect = () => {
  const location = useLocation()
  const { steps } = useCheckoutContext()

  const isMainRoot = location.pathname === PAYMENTS.CHECKOUT.DEFAULT

  const currentStepIndex = steps.findIndex(
    s => s.path === getLocalStorage(CHECKOUT_CURRENT_STEP)
  )

  const locationStepIndex = steps.findIndex(s => s.path === location.pathname)

  const isStepTooFar = locationStepIndex > currentStepIndex

  const storedStep = getLocalStorage(CHECKOUT_CURRENT_STEP)

  if (isMainRoot) {
    return <Navigate to={PAYMENTS.CHECKOUT.PLANS} replace />
  }

  if (storedStep && (isStepTooFar || currentStepIndex === -1)) {
    return <Navigate to={storedStep} replace />
  }

  if (!storedStep) {
    return <Navigate to={PAYMENTS.CHECKOUT.PLANS} replace />
  }

  return <CleanLayout />
}

export const routes = [
  {
    path: PAYMENTS.CHECKOUT.DEFAULT,
    element: (
      <FeatureFlag ff='SPA_CHECKOUT'>
        <CheckoutProvider>
          <CheckoutWrapper />

          <CheckoutStepsRedirect />
        </CheckoutProvider>
      </FeatureFlag>
    ),
    children: [
      {
        path: PAYMENTS.CHECKOUT.PLANS,
        element: <Plans />
      },
      {
        path: PAYMENTS.CHECKOUT.CONFIGURE,
        element: <Configure />
      },
      {
        path: PAYMENTS.CHECKOUT.PAYMENT,
        element: <Payment />
      },
      {
        path: PAYMENTS.CHECKOUT.CONFIRMATION,
        element: <Confirmation />
      }
    ]
  }
]
